import Vue from "vue";
import Vuex from "vuex";
import login from "@/store/modules/auth/login";
import user from "@/store/modules/auth/user";
import role from "@/store/modules/auth/role";
import proposal from "@/store/modules/frontend/proposal";
import { SnotifyPosition, SnotifyStyle } from 'vue-snotify';

Vue.use(Vuex);

const namespaced = true;

export default new Vuex.Store({
  namespaced,
  modules: {
    login,
    user,
    role,
    proposal
  },
  state: {},
  mutations: {

    showAlert: (state, data) => {

      let type = '';
      let position = '';

      switch (data.type) {
        case "error": {
          type = SnotifyStyle.error;
          break;
        }
        case "success": {
          type = SnotifyStyle.success;
          break;
        }
        case "info": {
          type = SnotifyStyle.info;
          break;
        }
        case "warning": {
          type = SnotifyStyle.warning;
          break;
        }
        case "async": {
          type = SnotifyStyle.async;
          break;
        }
        case "confirm": {
          type = SnotifyStyle.confirm;
          break;
        }
        case "prompt": {
          type = SnotifyStyle.prompt;
          break;
        }

        default: {
          type = SnotifyStyle.simple;
          break;
        }
      }

      switch (data.position) {
        case "leftTop": {
          position = SnotifyPosition.leftTop;
          break;
        }
        case "leftCenter": {
          position = SnotifyPosition.leftCenter;
          break;
        }
        case "leftBottom": {
          position = SnotifyPosition.leftBottom;
          break;
        }
        case "rightTop": {
          position = SnotifyPosition.rightTop;
          break;
        }
        case "rightCenter": {
          position = SnotifyPosition.rightCenter;
          break;
        }
        case "rightBottom": {
          position = SnotifyPosition.rightBottom;
          break;
        }
        case "centerCenter": {
          position = SnotifyPosition.centerCenter;
          break;
        }
        case "centerTop": {
          position = SnotifyPosition.centerTop;
          break;
        }
        case "centerBottom": {
          position = SnotifyPosition.centerBottom;
          break;
        }

        default: {
          position = SnotifyPosition.rightTop;
          break;
        }
      }
      Vue.$snotify.clear();

      Vue.$snotify.create({
        title: data.title,
        body: data.msg,
        config: {
          position: position,
          type: type,
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true,
        }
      })
    }
  },
  actions: {}
});
